import { RespuestaLecturaError } from '../../Mensajes';
import { llamadaAPI_DELETE, llamadaAPI_GET, llamadaAPI_POST, llamadaAPI_PUT } from '../../SQL';
import { TratamientoDeParametroParaURI, TratamientoDeVariableString } from '../../Varios';

export const function_ABM_EEX_Clientes_Listar = async () => {
    const NombreFuncion = "function_ABM_EEX_Clientes_Listar"

    try {
        const resulData = await llamadaAPI_GET("ABM_EEX_Clientes/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_EEX_Clientes_ListarSoloClientesPropios = async () => {
    const NombreFuncion = "function_ABM_EEX_Clientes_ListarSoloClientesPropios"

    try {
        const resulData = await llamadaAPI_GET("ABM_EEX_Clientes/ListarSoloClientesPropios/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            localStorage.getItem("IdPersona"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_EEX_Clientes_ListarReducidoParaSelectores = async () => {
    const NombreFuncion = "function_ABM_EEX_Clientes_ListarReducidoParaSelectores"

    try {
        const resulData = await llamadaAPI_GET("ABM_EEX_Clientes/ListarReducidoParaSelectores/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_EEX_Clientes_ListarDeReservasParaMarketing = async (Where) => {
    const NombreFuncion = "function_ABM_EEX_Clientes_ListarDeReservasParaMarketing"

    try {
        const resulData = await llamadaAPI_GET("ABM_EEX_Clientes/ListarDeReservasParaMarketing/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(Where));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_EEX_Clientes_Leer = async (IdCliente) => {
    const NombreFuncion = "function_ABM_EEX_Clientes_Leer"

    try {
        const resulData = await llamadaAPI_GET("ABM_EEX_Clientes/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdCliente);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_EEX_Clientes_LeerPorDNISinPassword = async (DNI) => {
    const NombreFuncion = "function_ABM_EEX_Clientes_LeerPorDNISinPassword"

    try {
        const resulData = await llamadaAPI_GET("ABM_EEX_Clientes/LeerPorDNISinPassword/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            DNI);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_EEX_Clientes_LeerPorMailDNI = async (DNI, EMail) => {
    const NombreFuncion = "function_ABM_EEX_Clientes_LeerPorMailDNI"

    try {
        const resulData = await llamadaAPI_GET("ABM_EEX_Clientes/LeerPorMailDNI/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            DNI + "/",
            EMail);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_EEX_Clientes_Generar_JSONBasico = async (IdCliente, Apellido, Nombre, CUIT, FechaNacimiento, Password, EMail, Telefono) => {
    const NombreFuncion = "function_ABM_EEX_Clientes_Generar_JSONBasico";

    try {

        const JSON = {
            IdCliente: IdCliente,
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            Apellido: Apellido,
            Nombre: Nombre,
            CUIT: await TratamientoDeVariableString(CUIT),
            FechaNacimiento: FechaNacimiento,
            Password: await TratamientoDeVariableString(Password),
            Locaciones: [
                {
                    Email: EMail,
                    Telefono: Telefono
                }
            ]
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_EEX_Clientes_InsertarBasico = async (Apellido, Nombre, CUIT, FechaNacimiento, Password, EMail, Telefono) => {
    const NombreFuncion = "function_ABM_EEX_Clientes_InsertarBasico";

    try {

        const clienteResult = await llamadaAPI_POST("ABM_EEX_Clientes/Basico/", 
            await function_ABM_EEX_Clientes_Generar_JSONBasico(0, Apellido, Nombre, CUIT, FechaNacimiento, Password, EMail, Telefono));

        return clienteResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_EEX_Clientes_ModificarBasico = async (IdCliente, Apellido, Nombre, CUIT, FechaNacimiento, Password, EMail, Telefono) => {
    const NombreFuncion = "function_ABM_EEX_Clientes_ModificarBasico";

    try {

        const clienteResult = await llamadaAPI_PUT("ABM_EEX_Clientes/ModificarBasico/", 
            await function_ABM_EEX_Clientes_Generar_JSONBasico(IdCliente, Apellido, Nombre, CUIT, FechaNacimiento, Password, EMail, Telefono));

        return clienteResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_EEX_Clientes_Insertar = async (Objeto) => {
    const NombreFuncion = "function_ABM_EEX_Clientes_Insertar";

    try {
        const objetoResult = await llamadaAPI_POST("ABM_EEX_Clientes/InsertarCompleto", Objeto);
        return objetoResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_EEX_Clientes_Modificar = async (Objeto) => {
    const NombreFuncion = "function_ABM_EEX_Clientes_Modificar";

    try {
        await llamadaAPI_PUT("ABM_EEX_Clientes/ModificarCompleto", Objeto);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_EEX_Clientes_Generar_JSON = async (IdCliente,
    MultiPlanta, MultiEmpresa, RazonSocial, Apellido, Nombre, CUIT, IdTipoIVA, CodigoCuentaContableDefault,
    Observaciones, IdTipoDocVentaDefault, IdProfesionalVendedorAsignado, CodigoCondicionVenta, CodigoListaPrecios,
    Categoria, HuellaDactilar, HuellaDactilarString, LimiteCreditoAviso, LimiteCreditoCorte, NombreFantasia,
    PuntosAcumulados, OpAutGenera, OpAutIdProveedor, OpAutIdTipoDocCompra, OpAutCodigoSubCC, OpAutCodigoCuentaFinanciera,
    OpAutCodigoPlantaCompra, SubidoEnNube, Agrupador,
    ListPlantas, ListEmpresas, Locaciones, RecargosBonificaciones) => {
    const NombreFuncion = "function_ABM_EEX_Clientes_Generar_JSON";

    try {

        const listaEmpresasConCodigo = (ListEmpresas && ListEmpresas.length > 0
            ? ListEmpresas
            : [{
                ABM_ZON_Empresas_CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                ABM_EEX_Clientes_IdCliente: IdCliente,
                Descripcion: "Default"
            }]
        ).map(empresa => ({
            ...empresa,
            ABM_EEX_Clientes_IdCliente: IdCliente
        }));

        const listaPlantasConCodigo = (ListPlantas && ListPlantas.length > 0
            ? ListPlantas
            : [{
                ABM_ZON_Plantas_CodigoPlanta: localStorage.getItem("CodigoPlanta"),
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                ABM_EEX_Clientes_IdCliente: IdCliente,
                Descripcion: "Default"
            }]
        ).map(planta => ({
            ...planta,
            ABM_EEX_Clientes_IdCliente: IdCliente
        }));

        const JSON = {
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            IdEstado: 10,
            IdCliente: IdCliente,
            MultiPlanta: MultiPlanta,
            MultiEmpresa: MultiEmpresa,
            RazonSocial: RazonSocial,
            Apellido: Apellido,
            Nombre: Nombre,
            CUIT: CUIT,
            IdTipoIVA: IdTipoIVA,
            CodigoCuentaContableDefault: CodigoCuentaContableDefault,
            Observaciones: Observaciones,
            IdTipoDocVentaDefault: IdTipoDocVentaDefault,
            IdProfesionalVendedorAsignado: IdProfesionalVendedorAsignado,
            CodigoCondicionVenta: CodigoCondicionVenta,
            CodigoListaPrecios: CodigoListaPrecios,
            Categoria: Categoria,
            HuellaDactilar: HuellaDactilar,
            HuellaDactilarString: HuellaDactilarString,
            LimiteCreditoAviso: LimiteCreditoAviso,
            LimiteCreditoCorte: LimiteCreditoCorte,
            NombreFantasia: NombreFantasia,
            PuntosAcumulados: PuntosAcumulados,
            OpAutGenera: OpAutGenera,
            OpAutIdProveedor: OpAutIdProveedor,
            OpAutIdTipoDocCompra: OpAutIdTipoDocCompra,
            OpAutCodigoSubCC: OpAutCodigoSubCC,
            OpAutCodigoCuentaFinanciera: OpAutCodigoCuentaFinanciera,
            OpAutCodigoPlantaCompra: OpAutCodigoPlantaCompra,
            SubidoEnNube: SubidoEnNube,
            Agrupador: Agrupador,
            ListPlantas: listaPlantasConCodigo,
            ListEmpresas: listaEmpresasConCodigo,
            Locaciones: Locaciones,
            RecargosBonificaciones: RecargosBonificaciones
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_EEX_Clientes_EnvioMailCambioEMail = async (IdCliente, CUIT, EMailParaCambiar) => {
    const NombreFuncion = "function_ABM_EEX_Clientes_EnvioMailCambioEMail"

    try {
        const resulData = await llamadaAPI_GET("ABM_EEX_Clientes/EnvioMailCambioEMail/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdCliente + "/" +
            CUIT + "/" +
            await TratamientoDeParametroParaURI(EMailParaCambiar));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_EEX_Clientes_Eliminar = async (IdCliente) => {
    const NombreFuncion = "function_ABM_EEX_Clientes_Eliminar"

    try {
        const resulData = await llamadaAPI_DELETE("ABM_EEX_Clientes/Eliminar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            IdCliente);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_EEX_Clientes_ClientesRelacionados = async (IdCliente) => {
    const NombreFuncion = "function_ABM_EEX_Clientes_ClientesRelacionados"

    try {
        const resulData = await llamadaAPI_GET("ABM_EEX_Clientes/ClientesRelacionados/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdCliente);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_EEX_Clientes_ClientesDeVendedor = async (IdProfesional) => {
    const NombreFuncion = "function_ABM_EEX_Clientes_ClientesDeVendedor"

    try {
        const resulData = await llamadaAPI_GET("ABM_EEX_Clientes/ClientesDeVendedor/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdProfesional);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_EEX_Clientes_LeerPorCorreoSinPassword = async (EMail) => {
    const NombreFuncion = "function_ABM_EEX_Clientes_LeerPorCorreoSinPassword"

    try {
        const resulData = await llamadaAPI_GET("ABM_EEX_Clientes/LeerPorCorreoSinPassword/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            TratamientoDeParametroParaURI(EMail));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_EEX_Clientes_LeerPorDNI = async (DNI, Password) => {
    const NombreFuncion = "function_ABM_EEX_Clientes_LeerPorDNI"

    try {
        const resulData = await llamadaAPI_GET("ABM_EEX_Clientes/LeerPorDNI/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            TratamientoDeParametroParaURI(DNI) + "/" +
            TratamientoDeParametroParaURI(Password));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_EEX_Clientes_LeerPorDNINombreFantasiaSinPassword = async (DNI, NombreFantasia) => {
    const NombreFuncion = "function_ABM_EEX_Clientes_LeerPorDNINombreFantasiaSinPassword"

    try {
        const resulData = await llamadaAPI_GET("ABM_EEX_Clientes/LeerPorDNINombreFantasiaSinPassword/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            TratamientoDeParametroParaURI(DNI) + "/" +
            TratamientoDeParametroParaURI(NombreFantasia));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_EEX_Clientes_LeerPorRazonSocial = async (RazonSocial) => {
    const NombreFuncion = "function_ABM_EEX_Clientes_LeerPorRazonSocial"

    try {
        const resulData = await llamadaAPI_GET("ABM_EEX_Clientes/LeerPorRazonSocial/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            TratamientoDeParametroParaURI(RazonSocial));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_EEX_Clientes_OlvidePassword = async (DNI) => {
    const NombreFuncion = "function_ABM_EEX_Clientes_OlvidePassword"

    try {
        const resulData = await llamadaAPI_GET("ABM_EEX_Clientes/OlvidePassword/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            TratamientoDeParametroParaURI(DNI));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_EEX_Clientes_EnvioMailRecuperoDePassword = async (CUIT) => {
    const NombreFuncion = "function_ABM_EEX_Clientes_EnvioMailRecuperoDePassword"

    try {
        const resulData = await llamadaAPI_GET("ABM_EEX_Clientes/EnvioMailRecuperoDePassword/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            TratamientoDeParametroParaURI(CUIT));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};
